/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./menu-link.vue?vue&type=template&id=069306cc&"
import script from "./menu-link.vue?vue&type=script&lang=js&"
export * from "./menu-link.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./menu-link.vue?vue&type=style&index=0&id=069306cc&prod&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports